import { chatNewDesign } from './chat-new-design';

export const featureFlags = { chatNewDesign };

export type FeatureFlagName = keyof typeof featureFlags;
